import { FC } from 'react';

import Text, { TextProps } from 'components/_core/Text';

const Title: FC<TextProps> = (props) => (
  <Text
    fontWeight="weight-500"
    marginBottom="space-4"
    size="lg"
    variant="primary"
    {...props}
  />
);

export default Title;
